import TexasSound from "../../texas_sound";
import GameUtil from "../../../../../utility/game_util";
import Utility from "../../../../../utility/utility";

//辅助类
export class TableHelp{

    static setNodeString(item:cc.Node,str:string){
        let richComp = item.getComponent(cc.RichText)
        if(richComp)
        {
            richComp.string = str;
        }else{
            let labelComp = item.getComponent(cc.Label)
            if(labelComp)
            {
                labelComp.string = str;
            }
        }
    }

    static AddChild(prefab:cc.Node,parent:cc.Node):cc.Node{
        if (parent === null || prefab === null) {
            cc.log('prefab or parent is null');
            return null;
        }
        let node = cc.instantiate(prefab);
        node.position = cc.Vec2.ZERO;
        node.angle = 0;
        node.scale = 1;
        node.active = true;
        parent.addChild(node);
        return node;
    }

    static moveToAction(node:cc.Node,pos:cc.Vec2,time:number,comp?:Function){
        let moveTo = cc.moveTo(time,pos);
        let callFunc = cc.callFunc(()=>{if (comp) {
            comp();
        }})
        node.runAction(cc.sequence(moveTo,callFunc));
    }

    static schedule(node : cc.Node , callback : ()=>void , delay : number) : cc.Action
    {
        let delayAction = cc.delayTime(delay);
        let sequence = cc.sequence(delayAction , cc.callFunc(callback));
        let action = cc.repeatForever(sequence);
        node.runAction(action);
        return action;
    }

    
    static repeatTimesAction(node:cc.Node,delay:number,times,callback:Function){
        let delayAction = cc.delayTime(delay);
        let sequence = cc.sequence(delayAction , cc.callFunc(callback));
        let action = cc.repeat(sequence,times);
        node.runAction(action);
        return action;
    }

    static isGrayAllNode(node:cc.Node,isGray:boolean){
        let coms = node.getComponents(cc.Sprite).concat(node.getComponentsInChildren(cc.Sprite))
        for (let i = 0; i < coms.length; i++) {
            const element = coms[i];
            if (isGray) {
                Utility.setGray(element)
            } else {
                Utility.resetGray(element)
            }

            let grayLabls = node.getComponents(cc.Label).concat(node.getComponentsInChildren(cc.Label))
            for (let i = 0; i < grayLabls.length; i++) {
                const element = grayLabls[i];
                if (isGray) {
                    //@ts-ignore
                    let mat = cc.Material.getBuiltinMaterial('2d-gray-sprite');
                    element.setMaterial(0,mat)
                }else{
                    
                }
            }
            
        }
    }


    //连续执行不同的计时
    static repeatTimes(node:cc.Node,delayTimes:number[],perComp:()=>void,comp:()=>void){
        let _delaytimes = delayTimes.concat([]);
        if (_delaytimes.length == 0) {
            return;//执行完成
        }
        let time = _delaytimes.shift();
        TableHelp.delay(node,()=>{
            if (perComp) {
                perComp();
            }
            if (_delaytimes.length == 0) {//执行完成
                if (comp) {
                    comp();
                }
            }else{
                TableHelp.repeatTimes(node,_delaytimes,perComp,comp);
            }
        },time);
    }

    static delay(node: cc.Node , callback : ()=>void , delay : number):cc.Action{
        let delayAction = cc.delayTime(delay);
        let func = cc.callFunc(()=>{
            if (callback) {
                callback();
            }
        })
        let sequence = cc.sequence(delayAction , func);
        node.stopAllActions();
        node.runAction(sequence);
        return sequence;
    }

    static rotateAction(node:cc.Node,time:number, callback:Function, endCallBack:Function){
        var run = cc.callFunc(function(){
            node.setScale(0.01, 1)
            TexasSound.playRotatePoker();
            if (callback != null){ callback() }
        })

        var endRun = cc.callFunc(function(){
            node.setScale(1, 1)
            if (endCallBack != null){ endCallBack() }
        })
        node.stopAllActions();
        node.runAction(cc.sequence(cc.scaleBy(0, 1), cc.scaleBy(time, 0.01, 1), run , cc.scaleBy(time, 100, 1), endRun))
    } 

    static rotateActionScaltoEx(node:cc.Node,time:number,scaleByTime:number, callback:Function, endCallBack:Function){
        let scalTo = cc.scaleTo(0.18,1.25);//0.18
        let callFunc = cc.callFunc(()=>{
            TableHelp.rotateActionEx(node,time,scaleByTime,callback,endCallBack);
        });
        let seq1 = cc.sequence(scalTo,callFunc);
        node.stopAllActions();
        node.runAction(seq1);
    }

    static rotateActionEx(node:cc.Node,time:number,scaleByTime:number, callback:Function, endCallBack:Function){
        var run = cc.callFunc(function(){
            node.setScale(0.01, 1)
            if (callback != null){ callback() }
        })

        var endRun = cc.callFunc(function(){
            node.setScale(1, 1)
            if (endCallBack != null){ endCallBack() }
        })
        node.stopAllActions();
        let seq = cc.sequence(cc.scaleTo(time, 0.01, 1), run , cc.scaleTo(time, 1, 1), endRun)
        let sqwan = cc.spawn(cc.scaleTo(scaleByTime, 1),seq)

        node.runAction(sqwan)
    } 

    //显示扑克
    static showPokerAction(node:cc.Node,time:number,callBack:Function){
        node.stopAllActions();
        node.opacity = 0;
        let show = cc.fadeIn(time);
        let endFunc = cc.callFunc(()=>{
            if (callBack != null) {
                callBack();
            }
        })
        node.runAction(cc.sequence(show,endFunc));
    }

    static throwPoker(start:cc.Node,node:cc.Node){

    }

    static getRightNumb(mount:number):number{
        if (mount == undefined) {
            cc.warn('mount 异常',mount)
            return 0;
        }
        let r   =   /^[0-9]*[1-9][0-9]*$/
        let m = mount
        if (!r.test(mount.toString()) ) {
            m = parseFloat(mount.toFixed(2));
        }
        return m;
    }

    static getRightMount(mount:number):number{
        if (mount == undefined) {
            return 0;
        }
        //截断小数
        let num = Math.floor(mount * 1000 / 10) / 100;
        let _mount = num.toFixed(2);
        return Number(_mount);
    }

    //千分位显示
    static addThousands(number) {
        return GameUtil.currencyFormatting(number);
        // if (number == undefined) {
        //     return '0';
        // }
        // if(number==0){
        //     return number;
        // }else if(number==0.0){
        //     return number;
        // }
        // var num = number + "";
        // num = num.replace(new RegExp(",","g"),"");
        // // 正负号处理
        // var symble = "";
        // if(/^([-+]).*$/.test(num)) {
        //     symble = num.replace(/^([-+]).*$/,"$1");
        //     num = num.replace(/^([-+])(.*)$/,"$2");
        // }
        // if(/^[0-9]+(\.[0-9]+)?$/.test(num)) {
        //     var num = num.replace(new RegExp("^[0]+","g"),"");
        //     if(/^\./.test(num)) {
        //         num = "0" + num;
        //     }
        //     var decimal = num.replace(/^[0-9]+(\.[0-9]+)?$/,"$1");
        //     var integer= num.replace(/^([0-9]+)(\.[0-9]+)?$/,"$1");
        //     var re=/(\d+)(\d{3})/;
        //     while(re.test(integer)){
        //         integer = integer.replace(re,"$1,$2");
        //     }
        //     return symble + integer + decimal;
        // } else {
        //     return number;
        // }
    }
}